import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/ATS/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/BentoSection/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/CtaButton/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/Faq/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/GlobalStyle/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/HeroSection/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/HeroSection/Video.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/LogoCarousel/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/NewsPill/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/RetroGrid/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui/Testimonials/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/WebsiteTypography/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/BgPattern/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/Website/Resources/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/ui/WebsiteBenefits/styles.module.scss");
